/**
 * The order chooser and switcher rows appear in.
 *
 * ┌─ ITS OWN MODULE FOR A BUNDLING REASON, NOT A TIDINESS ONE. ──────────────┐
 * │ `chooserRows.ts` reads service-line labels out of the entry plane's      │
 * │ `servicePickerIndex.ts`, so importing anything from it pulls the whole   │
 * │ picker index in behind it. `EngagementSwitcher` is mounted from `Shell`, │
 * │ which BOTH origins build — so putting this one function there would ship │
 * │ the customer service picker into the staff bundle, which is the same     │
 * │ class of leak `main.customer.tsx` documents for MSAL and the staff       │
 * │ strings.                                                                 │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
import type { ReachableEngagement } from '@nimer/contracts/person'

/**
 * Anything with questions waiting on this person comes first.
 *
 * The reason a participant reaches the chooser mid-session is usually a
 * forward they were just emailed about; making them hunt for it defeats the
 * switcher. Ties keep the query's newest-first order, which `sort` preserves
 * because it is stable.
 */
export function orderRows(rows: readonly ReachableEngagement[]): readonly ReachableEngagement[] {
  return [...rows].sort((a, b) => Number(b.open_for_me > 0) - Number(a.open_for_me > 0))
}
